// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__105bt","name":"styles_name__3Eesa","phone":"styles_phone__3FpNK"};